export const PRODUCT_URLS = {
  GET_ALL_PRODUCT: '/product',
  GET_ALL_PRODUCT_NEW: '/product/admin',
  GET_ALL_PRODUCT_OPTION_TYPE: '/application/request-option',
  UPDATE_PRODUCT: '/product'
};
